import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

// Legal content helpers targeting the legal_i18n collection
export const listenLegalContent = (pageId, callback) => {
  const docRef = doc(db, 'legal_i18n', pageId);
  return onSnapshot(docRef, (snapshot) => {
    const raw = snapshot.data();
    // Support both shapes: { i18n: {...} } and legacy { fr: {...}, ... }
    const i18n = raw?.i18n || raw || null;
    callback(i18n);
  });
};

export const saveLegalContent = async (pageId, i18nData) => {
  const docRef = doc(db, 'legal_i18n', pageId);
  await setDoc(docRef, { i18n: i18nData }, { merge: true });
};

// Merged helpers to work across split docs while keeping Admin UI unified
const PAGE_DOCS = {
  mentions: 'legal_mentions',
  cookies: 'legal_cookies',
  assurances: 'legal_assurances',
  cgv: 'legal_cgv',
  privacy: 'legal_privacy',
};

const KEY_PREFIX_TO_DOC = {
  mentions_: PAGE_DOCS.mentions,
  cookies_: PAGE_DOCS.cookies,
  assurances_: PAGE_DOCS.assurances,
  cgv_: PAGE_DOCS.cgv,
  privacy_: PAGE_DOCS.privacy,
};

export const listenLegalContentMerged = (_unusedPageId, callback) => {
  // Listen each page doc and merge by language
  const unsubscribes = [];
  const state = {}; // { docId: i18n }

  const emit = () => {
    const merged = {};
    Object.values(state).forEach((i18n) => {
      const data = i18n?.i18n || i18n || {};
      Object.keys(data).forEach((lang) => {
        merged[lang] = { ...(merged[lang] || {}), ...(data[lang] || {}) };
      });
    });
    callback(Object.keys(merged).length ? merged : null);
  };

  Object.values(PAGE_DOCS).forEach((docId) => {
    const ref = doc(db, 'legal_i18n', docId);
    const unsub = onSnapshot(ref, (snap) => {
      state[docId] = snap.data() || {};
      emit();
    });
    unsubscribes.push(unsub);
  });

  return () => unsubscribes.forEach((u) => u && u());
};

export const saveLegalContentMerged = async (_unusedPageId, i18nData) => {
  // Partition keys by prefix per language and write to their respective docs
  const updatesByDoc = {
    [PAGE_DOCS.mentions]: {},
    [PAGE_DOCS.cookies]: {},
    [PAGE_DOCS.assurances]: {},
    [PAGE_DOCS.cgv]: {},
    [PAGE_DOCS.privacy]: {},
  };

  Object.entries(i18nData || {}).forEach(([lang, kv]) => {
    Object.entries(kv || {}).forEach(([key, value]) => {
      const prefix = `${key.split('_')[0]}_`;
      const targetDoc = KEY_PREFIX_TO_DOC[prefix];
      if (!targetDoc) return; // ignore unknown keys
      // Build nested structure: { i18n: { [lang]: { [key]: value } } }
      updatesByDoc[targetDoc].i18n = updatesByDoc[targetDoc].i18n || {};
      updatesByDoc[targetDoc].i18n[lang] = updatesByDoc[targetDoc].i18n[lang] || {};
      updatesByDoc[targetDoc].i18n[lang][key] = value;
    });
  });

  const writes = Object.entries(updatesByDoc)
    .filter(([, data]) => Object.keys(data).length > 0)
    .map(([docId, data]) => setDoc(doc(db, 'legal_i18n', docId), data, { merge: true }));

  await Promise.all(writes);
};


